import { i18n } from '@/plugins/i18n';
import { useLocale } from 'vuetify';

export function setLocale(locale: string = window.navigator.language) {
    if (!i18n.global.availableLocales.includes(locale)) {
        console.warn(`Locale "${locale}" is not available. Using default locale: "${i18n.global.locale.value}"`);
        return;
    };

    // Set locale for Vue I18n
    i18n.global.locale.value = locale;

    // Set locale for Vuetify
    const { current } = useLocale();
    current.value = locale;

    // Set lang attribute for html tag
    document.querySelector('html')!.setAttribute('lang', locale);
}
